





























import { Component, namespace, mixins } from 'nuxt-property-decorator'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'
import LazyHydrate from 'vue-lazy-hydration'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import { filterUrl } from '~/assets/filters/url'
import MixinGeneral from '~/assets/mixins/general'

const pageStore = namespace('page')
const siteStore = namespace('site')

@Component({
  filters: {
    filterUrl,
  },
  components: {
    LazyHydrate,
    ComponentIcon: () => import('~/components/icon/icon.vue'),
  },
})
export default class ComponentNavigationBreadcrumbs extends mixins(
  MixinGeneral
) {
  @pageStore.State('breadcrumbs') private items!: IBreadcrumbsItem[]
  @siteStore.State('origin') private origin!: string

  private amountItems = 0

  private mdiChevronRight = mdiChevronRight
  private mdiChevronLeft = mdiChevronLeft

  private mounted(): void {
    this.$emit('loaded')
  }

  private get renderItems() {
    if (this.items.length === 0) {
      return []
    }
    if (this.$device.isMobileOrTablet) {
      return [this.items[this.items.length - 1]]
    }
    return this.items
  }

  private get structuredData() {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: this.itemListElement,
    }
  }

  private get itemListElement() {
    return this.items.map((item, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        name: item.title,
        item: this.origin + item.url,
      }
    })
  }

  private head() {
    if (this.items.length === 0) {
      return {}
    }
    return {
      script: [
        {
          hid: 'ld-breadcrumbs',
          json: this.structuredData,
          type: 'application/ld+json',
        },
      ],
    }
  }

  private created(): void {
    this.amountItems = this.items.length
  }
}
